import styled from '@emotion/styled';
import { Box } from '@mui/material';

import { neutrals } from '@widget/toolbox/style/theme/common/ThemeProvider/colors';

export const RegionalTrendSection = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: 1fr;
  }
  padding: 24px;
  gap: 24px;
  border-radius: 4px;
  border: 0.5px solid ${neutrals.lighter};
  box-shadow: 0px 1px 6px 0px #00000026;
`;
